import { Box, Button, Icon, Text, VStack } from '@chakra-ui/react'
import { LuMonitorSmartphone } from 'react-icons/lu'
import { useNavigate } from 'react-router-dom'
import { logoutApi } from '@/api/auth.api'
import { useUserStore } from '@/stores/user.store'

export default function MobileNotSupportedPage() {
  const navigate = useNavigate()
  const { setUser } = useUserStore()

  const logout = async () => {
    try {
      await logoutApi()
    } catch (e) {
      console.warn('Logout safely ignored:', e)
    } finally {
      setUser(null)
      navigate('/login', { replace: true })
    }
  }

  return (
    <Box minH="100vh" bg="bg.canvas" py={{ base: 8, md: 10 }}>
      <Box maxW="3xl" mx="auto" px={{ base: 4, md: 0 }}>
        <Button variant="ghost" onClick={logout} mb={6}>
          Abmelden
        </Button>

        <Box
          bg="bg"
          borderRadius="16px"
          boxShadow="0px 0px 1px rgba(24,24,27,0.3), 0px 4px 8px rgba(24,24,27,0.1)"
          p={{ base: 8, md: 10 }}
          w="full"
          maxW="768px"
          mx="auto"
        >
          <VStack gap={6} align="center" textAlign="center">
            <Icon as={LuMonitorSmartphone} boxSize={10} color="fg.subtle" />

            <Text fontSize="20px" lineHeight="28px" fontWeight="600" color="fg">
              Derzeit nicht auf Mobilgeräten
            </Text>

            <Text fontSize="14px" lineHeight="22px" color="fg.muted" maxW="480px">
              Derzeit ist die Software noch nicht für Mobilgeräte unterstützt. Wir arbeiten bereits
              mit Hochdruck daran, Ihnen diese Möglichkeit bald zur Verfügung zu stellen. Zunächst
              fokussieren wir uns auf die meistgefragten Funktionen.
            </Text>
          </VStack>
        </Box>
      </Box>
    </Box>
  )
}
